var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 2.66406V16.6641H2.49951V2.66406H16.4995ZM17.5995 0.664062H1.39951C0.899512 0.664062 0.499512 1.06406 0.499512 1.56406V17.7641C0.499512 18.1641 0.899512 18.6641 1.39951 18.6641H17.5995C17.9995 18.6641 18.4995 18.1641 18.4995 17.7641V1.56406C18.4995 1.06406 17.9995 0.664062 17.5995 0.664062ZM8.49951 4.66406H14.4995V6.66406H8.49951V4.66406ZM8.49951 8.66406H14.4995V10.6641H8.49951V8.66406ZM8.49951 12.6641H14.4995V14.6641H8.49951V12.6641ZM4.49951 4.66406H6.49951V6.66406H4.49951V4.66406ZM4.49951 8.66406H6.49951V10.6641H4.49951V8.66406ZM4.49951 12.6641H6.49951V14.6641H4.49951V12.6641Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListV2);
export default __webpack_public_path__ + "static/media/ListV2.ed49e81b7d03c4aea8bcada21e94325d.svg";
export { ForwardRef as ReactComponent };